import { render, staticRenderFns } from "./AppNotification.vue?vue&type=template&id=5725b367&"
import script from "./AppNotification.vue?vue&type=script&lang=js&"
export * from "./AppNotification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports